<div class="filter-group" data-group-visibility-id="showSpecialEquipmentFiltersPoe2">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showSpecialEquipmentFiltersPoe2" (click)="filter.groupVisibility.showSpecialEquipmentFiltersPoe2 = !filter.groupVisibility.showSpecialEquipmentFiltersPoe2; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Special Equipment" [activeRules]="activeRules.specialEquipmentFiltersPoe2"></span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showSpecialEquipmentFiltersPoe2) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showSpecialEquipmentFiltersPoe2">

      <div class="filter filter-property full-span">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showSpecialGear" (click)="toggleHighlightSpecialGear()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Special Gear" [additionalContent]="specialGearStylePreview" ruleId="gear-special-gear">
            <span class="rare-item-color">Sactrificial Regalia</span>, dropped from Atziri's Vault after defeating her in the Temple,
            and <span class="rare-item-color">Grasping Mail</span>, dropped from Grasping Orchid upon giving it 60 (Refined) Breach Rings.
            <ng-template #specialGearStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherGearSpecialGear"
                [alignLeft]="true"
                [active]="filter.showSpecialGear"
                exampleName="Sacrificial Regalia"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            </ng-template>
          </span>
        </span>
      </div>

      <div class="filter filter-property full-span">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showAnointedAmulets" (click)="toggleHighlightAnointedAmulets()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Double-Anointed Amulets" [additionalContent]="anointedAmuletsStylePreview" ruleId="jewellery-anointed-amulets">
            Double-Anointed Amulets can drop in Delirium Loathsome Mire.
            <ng-template #anointedAmuletsStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherJewelleryAnointedAmulets"
                [alignLeft]="true"
                [active]="filter.showAnointedAmulets"
                exampleName="Gold Amulet"
                [rarity]="Rarity.Normal"></app-equipment-tier-picker>
            </ng-template>
          </span>
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showExcellentSpecialJewelleryBaseTypes">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showExcellentSpecialJewelleryBaseTypes" (click)="toggleHighlightExcellentSpecialJewelleryBaseTypes()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="{{ isMobile() ? 'Special Jewellery' : 'Excellent Special Jewellery' }}" [additionalContent]="excellentSpecialJewelleryBaseTypesStylePreview" ruleId="jewellery-special-excellent">
            Highlights Excellent and Good Special (restricted drop) Jewellery, optionally of the specified minimum item level.
            <br /><br /><strong>Excellent</strong>: {{ excellentSpecialJewelleryBaseTypes.join(', ') }}
            <br /><strong>Good</strong>: {{ goodSpecialJewelleryBaseTypes.join(', ') }}
            <br ><br />You can specify which Jewellery Base Types are Excellent and Good in the <a href="/tier-list/jewellery">Jewellery Tier List</a> tab.
            <br /><br />Note: <span class="normal-item-color">Normal</span> rarity Excellent and Good Jewellery Base Types are handled by the Crafting Bases rules, Tiered Unidentified <span class="rare-item-color">Rare</span> and <span class="magic-item-color">Magic</span> Special Jewellery are handled by the Unidentified Jewellery rules.
            <ng-template #excellentSpecialJewelleryBaseTypesStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherJewelleryExcellentSpecialBaseTypes"
                [alignLeft]="true"
                [active]="filter.showExcellentSpecialJewelleryBaseTypes"
                exampleName="{{ excellentSpecialJewelleryBaseTypes[0] || 'Tenebrous Amulet' }}"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showExcellentSpecialJewelleryBaseTypes"
            [(ngModel)]="filter.showExcellentSpecialJewelleryBaseTypesMinItemLevel" (change)="updateFilter()">
          <span class="sep"></span>
          <app-filter-checkbox-group
            [filter]="filter"
            filterPropertyName="showGoodSpecialJewelleryBaseTypes"
            labelText="Good"
            [equipmentType]="EquipmentType.OtherJewelleryGoodSpecialBaseTypes"
            [exampleName]="goodSpecialJewelleryBaseTypes[0] || 'Dusk Amulet'"
            [rarity]="Rarity.Rare"
            [disabledWhen]="!filter.showExcellentSpecialJewelleryBaseTypes"></app-filter-checkbox-group>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showGoodSpecialJewelleryBaseTypes"
            [(ngModel)]="filter.showGoodSpecialJewelleryBaseTypesMinItemLevel" (change)="updateFilter()">
        </span>
      </div>

      <div class="filter filter-property full-span" [class.disabled]="!filter.showOtherSpecialJewelleryBaseTypes">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.showOtherSpecialJewelleryBaseTypes" (click)="toggleHighlightOtherSpecialJewelleryBaseTypes()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Remaining Special Jewellery" [additionalContent]="otherSpecialJewelleryBaseTypesStylePreview" ruleId="jewellery-special-other">
            Shows all, or optionally the selection of remaining Special Jewellery, optionally of the specified minimum item level.

            <br /><br />You can specify which Jewellery Base Types belongs to which tier on the <a href="/tier-list/jewellery">Jewellery Tier List</a> tab.

            <br /><br />Note that <span class="normal-item-color">Normal</span> rarity Excellent and Good Crafting Bases rules, <span class="rare-item-color">Rare</span> and <span class="magic-item-color">Magic</span> Tiered Unidentified Jewellery rules, and the Excellent and Good Special Jewellery rules above take precedence when enabled. This rule targets all remaining Special Jewellery, including Excellent and Good Special Jewellery when those rules are disabled.
            <ng-template #otherSpecialJewelleryBaseTypesStylePreview>
              <app-equipment-tier-picker
                [equipmentType]="EquipmentType.OtherJewelleryOtherSpecialBaseTypes"
                [alignLeft]="true"
                [active]="filter.showOtherSpecialJewelleryBaseTypes"
                exampleName="{{ otherSpecialJewelleryBaseTypes[0] || 'Lament Amulet' }}"
                [rarity]="Rarity.Rare"></app-equipment-tier-picker>
            </ng-template>
          </span>
          <span class="sep"></span>
          <app-autocomplete
            [options]="allOtherSpecialJewelleryBaseTypesTypes"
            [disabled]="!filter.showOtherSpecialJewelleryBaseTypes"
            [showOptions]="true"
            [selectedValues]="filter.showOtherSpecialJewelleryBaseTypesTypes || ['All']"
            (selectedValuesChange)="highlightOtherSpecialJewelleryBaseTypesTypesChanged($event)"
          ></app-autocomplete>
          <span class="sep"></span>
          @if (!isMobile()) {
            <div class="filter-title filter-label">
              iLvl
            </div>
            <span class="sep"></span>
          }
          <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.minWidth]="isMobile() ? '45px' : null"
            [disabled]="!filter.showOtherSpecialJewelleryBaseTypes"
            [(ngModel)]="filter.showOtherSpecialJewelleryBaseTypesMinItemLevel" (change)="updateFilter()">
        </span>
      </div>

    </div>
  }
</div>
